import { useEffect, useState, useCallback } from "react";

const KEY = "wishlist:v1";

function read(): string[] {
  if (typeof window === "undefined") return [];
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

function write(list: string[]) {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("wishlist:change"));
}

export function useWishlist() {
  const [list, setList] = useState<string[]>([]);
  useEffect(() => {
    setList(read());
    const h = () => setList(read());
    window.addEventListener("wishlist:change", h);
    window.addEventListener("storage", h);
    return () => {
      window.removeEventListener("wishlist:change", h);
      window.removeEventListener("storage", h);
    };
  }, []);

  const has = useCallback((id: string) => list.includes(id), [list]);
  const toggle = useCallback((id: string) => {
    const curr = read();
    const next = curr.includes(id) ? curr.filter((x) => x !== id) : [...curr, id];
    write(next);
  }, []);
  const remove = useCallback((id: string) => {
    write(read().filter((x) => x !== id));
  }, []);

  return { list, has, toggle, remove };
}
